/**
 * Vendedoras (puesto 18): no mostrar contactos WhatsApp sin prospecto CRM.
 * Un socket bump puede meter chats nuevos sin folio/idprospectos.
 */

export function esPuestoVendedora18 (usuario) {
  return Number(usuario && usuario.idpuesto) === 18
}

/** Folio usable (API a veces manda 0 / '0' / ''). */
export function chatTieneFolioUsable (chat) {
  const f = chat && chat.folio
  if (f == null || f === 0 || f === '0') return false
  return String(f).trim().length > 0
}

export function chatTieneIdProspecto (chat) {
  const id = Number(chat && chat.idprospectos)
  return Number.isFinite(id) && id > 0
}

/** Tiene folio o idprospectos (al menos uno). */
export function chatTieneFolioOProspecto (chat) {
  return chatTieneFolioUsable(chat) || chatTieneIdProspecto(chat)
}

/**
 * Para puesto 18: ocultar si no hay folio ni idprospectos.
 * Admins / otros puestos: no aplica.
 */
export function debeOcultarChatSinProspectoPuesto18 (usuario, chat) {
  if (!esPuestoVendedora18(usuario)) return false
  return !chatTieneFolioOProspecto(chat)
}

/** Solo un mensaje saliente de asesor humano (no Susana) limpia reasignado. */
export function mensajeLimpiaReasignado (msg) {
  if (!msg || typeof msg !== 'object') return false
  if (Number(msg.mio) !== 1) return false
  const iderp = Number(msg.iderp)
  if (Number.isFinite(iderp) && iderp > 0 && iderp !== 3176) return true
  const nombre = String(msg.nombre_completo || msg.nombre || '').trim().toLowerCase()
  if (!nombre) return false
  if (nombre === 'sistema' || nombre.includes('susana')) return false
  return true
}

/** Entró / está vía Agente IA (Susana). Misma señal que el chip "IA" de la lista. */
export function chatViaAgenteIA (chat) {
  if (!chat) return false
  if (Number(chat.via_ia) === 1) return true
  if (Number(chat.via_susana) === 1) return true
  if (Number(chat.usuario_asignado) === 3176) return true
  if (chat.id_vendedora_posible != null && Number(chat.id_vendedora_posible) > 0) return true
  return String(chat.utm_source || '').toUpperCase() === 'SUSANA_IA'
}
